export function Step2Icon2() {
    return (
        <svg width="61" height="57" viewBox="0 0 61 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M26.2727 34.9359C25.3251 36.1664 24.8726 37.8128 25.0311 39.4529L25.3948 43.2189C25.658 45.9446 27.6378 48 30 48C32.3622 48 34.342 45.9446 34.6052 43.2189L34.9689 39.4529C35.1274 37.8128 34.6749 36.1664 33.7273 34.9359C32.7799 33.7056 31.4214 33 30 33C28.5786 33 27.22 33.7054 26.2727 34.9359Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M37.0383 32.5534C38.7133 34.4437 39.5132 36.9727 39.2332 39.4924L38.8421 43.0111C38.6991 44.2977 38.2765 45.4887 37.642 46.5287L38.45 46.8488C41.7757 48.1663 43.9245 51.3469 43.9245 54.952V56H60V35.2589C60 32.1447 58.1436 29.3971 55.2708 28.259L52.0926 27C50.3763 28.1778 48.3065 28.8606 46.0904 28.8606C43.8742 28.8606 41.8043 28.1777 40.0881 27L36.9097 28.259C35.7726 28.7094 34.7808 29.4224 34 30.3333C35.1466 30.841 36.1868 31.5924 37.0383 32.5534V32.5534Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M20 54.9151V56H40V54.9151C40 52.6813 38.7152 50.7103 36.7271 49.8939L34.5499 49C33.2325 49.8829 31.6693 50.3926 30.0001 50.3926C28.3308 50.3926 26.7675 49.8829 25.4502 49L23.2731 49.8939C21.2848 50.7103 20 52.6813 20 54.9151Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M20.9121 27C19.1959 28.1778 17.126 28.8607 14.9098 28.8607C12.6936 28.8607 10.6237 28.1778 8.90746 27.0001L5.72921 28.259C2.85641 29.3971 1 32.1447 1 35.2589V56H17.0754V54.952C17.0754 51.3469 19.2244 48.1661 22.55 46.8488L23.3579 46.5287C22.7235 45.4889 22.3009 44.2978 22.1579 43.0112L21.7668 39.4925C21.4868 36.9728 22.2867 34.4437 23.9617 32.5535C24.8133 31.5924 25.8534 30.841 27 30.3333C26.2192 29.4226 25.2274 28.7095 24.0903 28.2589L20.9121 27Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M7.23544 5.34099C8.04342 4.45149 8.97805 3.69928 10 3.09975C9.41954 1.84899 8.14003 1 6.66572 1C4.64442 1 3 2.61875 3 4.60838C3 6.15644 4.01413 7.49364 5.422 8C5.89548 7.04438 6.50244 6.1479 7.23544 5.34099V5.34099Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M9.69646 7.83048C8.81022 9.01319 8.23072 10.4592 8 11.9921C8.10543 11.9959 8.21097 12 8.31608 12C10.3904 12 12.3986 11.2831 14.1237 9.92696L15 9.23806L15.8763 9.92696C17.6013 11.2832 19.6096 12 21.6838 12C21.789 12 21.8945 11.9959 22 11.9921C21.7694 10.4593 21.1898 9.01319 20.3035 7.83048C18.9556 6.03171 17.0225 5 15 5C12.9776 5 11.0445 6.03158 9.69646 7.83048Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M15.0001 26C18.409 26 21.2659 23.1724 21.6458 19.4225L22 15.9261C21.9131 15.9279 21.8261 15.9322 21.7393 15.9322C19.3646 15.9322 17.0551 15.2673 15 14C12.9449 15.2671 10.6353 15.9322 8.26068 15.9322C8.17396 15.9322 8.08693 15.9279 8 15.9261L8.35424 19.4225C8.73429 23.1724 11.5914 26 15.0001 26Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M42.5523 13C44.516 13 46.3842 12.2647 47.9549 10.8736L48.8976 10.0387L49.8404 10.8736C50.6913 11.6271 51.8073 12.2279 53 12.5955C52.856 10.8302 52.2455 9.14524 51.2373 7.80255C49.9003 6.02148 47.9827 5 45.9765 5C43.9702 5 42.0527 6.02148 40.7155 7.80255C39.7943 9.02948 39.2047 10.5423 39 12.1408C40.1241 12.7044 41.3349 13 42.5523 13V13Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M46.0106 27C49.448 27 52.3289 24.188 52.7119 20.4587L53 17.6543C51.5668 17.3213 50.1945 16.7529 49.0164 16C47.0581 17.3072 44.8278 17.9923 42.5009 17.9923C41.3161 17.9923 40.1362 17.8065 39 17.4477L39.3094 20.4587C39.6924 24.188 42.5734 27 46.0106 27Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
        </svg>
    )
}
